import type { HtmlAttributes, HtmlAttributesWithChildren } from '@studio/design-system/props';
import type { Accessor } from '@studio/react-utils';
import type { T_Optional } from '@tryiris-ai/js-types';

/** `<Placeholder>` properties. */
export type PlaceholderProps = Props;

/** `<BottomTray>` properties. */
export type Props = HtmlAttributes;

/** `<Root>` properties. */
export type RootProps = HtmlAttributesWithChildren<{ tab: Accessor<Tab, unknown> }>;

/** @internal */
export type TriggersProps = HtmlAttributesWithChildren<T_Optional<{ disabled: boolean }>>;

/** Tabs. */
export enum Tab {
  Presets = 'presets',
  Tracking = 'tracking'
}
